import { useState } from "react"
import { AwardEntity } from "../../Objects/Awards/AwardEntity"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { EAutoType } from "../../Enum/EAutoType"
import { EMoneyConditionType } from "../../Enum/EMoneyConditionType"

export const useCreateAward = () => {
  const [name, setName] = useState<string>("")
  const [description, setDescription] = useState<string>("")
  const [valueDiscountWhenWon, setValueDiscountWhenWon] = useState<string>("")

  const [minimumValue, setMinimumValue] = useState<string>("")
  const [countToWin, setCountToWin] = useState<string>("")

  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)
  const [conditionType, setConditionType] = useState<EMoneyConditionType>(EMoneyConditionType.Percentage)
  const [isAutomatic, setIsAutomatic] = useState<EAutoType>(EAutoType.NotAuto)

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)
  const handleMinimumCoastChange = (e: React.ChangeEvent<HTMLInputElement>) => setMinimumValue(e.target.value)
  const handlecountToWinChange = (e: React.ChangeEvent<HTMLInputElement>) => setCountToWin(e.target.value)
  const handleValueWhenWon = (e: React.ChangeEvent<HTMLInputElement>) => setValueDiscountWhenWon(e.target.value)
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as EEnableStatusType)

  const handleInitialValue = (awardEntity: AwardEntity | null | undefined) => {
    if (awardEntity) {
      setValueDiscountWhenWon(awardEntity.valueDiscountWhenWon.toString())
      setIsAutomatic(awardEntity.isAutomatic)
      setName(awardEntity.name)
      setMinimumValue(String(awardEntity.minimumValue ?? ""))
      setDescription(awardEntity.description)
      setConditionType(awardEntity.conditionType)
      setStatus(awardEntity.status)
      setCountToWin(String(awardEntity.countToWin ?? ""))
    }
  }

  const handleSubmitForm = (id?: number): AwardEntity | { errors: ValidationError[] } => {
    return new AwardEntity({
      status: status,
      id: id,
      minimumValue: minimumValue.toNumber(),
      countToWin: countToWin.toNumber(),
      name: name,
      description: description,
      isAutomatic: isAutomatic,
      conditionType: conditionType,
      valueDiscountWhenWon: Number.parseFloat(valueDiscountWhenWon),
    })
  }

  return {
    name,
    valueDiscountWhenWon,
    description,
    status,
    minimumValue,
    countToWin,
    isAutomatic,
    setConditionType,
    handleValueWhenWon,
    setIsAutomatic,
    handleNameChange,
    handlecountToWinChange,
    handleDescriptionChange,
    handleMinimumCoastChange,
    handleStatusChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
